import { Box, Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

import { type NavigationItemProps } from '../NavigationItem';
import { DesktopSidebarItem } from './DesktopSidebarItem';
import { SGroup, SHelpGroup, SMainGroup, SSectionTitle } from './styled';
import { DesktopSidebarNavigationProps } from './types';

const renderItems = (items: NavigationItemProps[], variant: 'primary' | 'secondary', isOpen: boolean) =>
  items.map((item) => (
    <DesktopSidebarItem key={item.dataTestId ?? item.title} isOpen={isOpen} item={item} variant={variant} />
  ));

export const DesktopSidebarNavigation = ({
  helpNavigation = [],
  isOpen = true,
  logoContainer,
  mainNavigation,
  profileContainer,
  promoContainer,
  teamspaceContainer,
  toolsNavigation = [],
  toolsTitle,
  ...props
}: DesktopSidebarNavigationProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Stack aria-label={t('common.navigationSidebar')} component="nav" flexGrow={1} {...props}>
      {logoContainer}
      {teamspaceContainer}

      <SMainGroup data-testid="desktop-sidebar-main">{renderItems(mainNavigation, 'primary', isOpen)}</SMainGroup>

      {toolsNavigation.length > 0 && (
        <>
          {toolsTitle && (
            <SSectionTitle $isOpen={isOpen} aria-hidden={!isOpen} data-testid="desktop-sidebar-tools-title">
              <span>{toolsTitle}</span>
            </SSectionTitle>
          )}
          <SGroup data-testid="desktop-sidebar-tools">{renderItems(toolsNavigation, 'secondary', isOpen)}</SGroup>
        </>
      )}

      <Box flexGrow={1} />

      {promoContainer}

      {helpNavigation.length > 0 && (
        <SHelpGroup data-testid="desktop-sidebar-help">{renderItems(helpNavigation, 'secondary', isOpen)}</SHelpGroup>
      )}

      {profileContainer}
    </Stack>
  );
};
